<template>
  <article class="anomaly-card">
    <header v-if="title" class="card-header">
      <h3 class="card-title">{{ title }}</h3>
    </header>

    <DualloLoaderWrapper :loading="result == null" message="Loading anomaly data...">
      <div v-if="result" class="card-body">
        <div class="anomaly-hero">
          <div class="anomaly-number">{{ formatNumber(result.total) }}</div>
          <div class="anomaly-sub-label">Total Anomalies</div>
        </div>

        <div class="anomaly-breakdown">
          <div class="breakdown-item">
            <span class="breakdown-dot dot-pending"></span>
            <span class="breakdown-label">Pending</span>
            <span class="breakdown-value">{{ formatNumber(result.pending) }}</span>
          </div>
          <div class="breakdown-item">
            <span class="breakdown-dot dot-accepted"></span>
            <span class="breakdown-label">Accepted</span>
            <span class="breakdown-value">{{ formatNumber(result.accepted) }}</span>
          </div>
          <div class="breakdown-item">
            <span class="breakdown-dot dot-rejected"></span>
            <span class="breakdown-label">Rejected</span>
            <span class="breakdown-value">{{ formatNumber(result.rejected) }}</span>
          </div>
        </div>
      </div>
    </DualloLoaderWrapper>
  </article>
</template>

<script>
import DualloLoaderWrapper from './DualloLoaderWrapper.vue';

export default {
  name: 'AnomalyBreakdownComponent',
  components: { DualloLoaderWrapper },
  props: {
    title: { type: String, default: "" },
    dataFetcher: { type: Function, default: null }
  },
  data() {
    return { result: null };
  },
  async mounted() {
    try {
      if (this.dataFetcher != null) {
        this.result = await this.dataFetcher();
      }
    } catch (error) {
      console.error(`Error fetching data`, error);
    }
  },
  methods: {
    formatNumber(n) {
      if (n == null) return '0';
      return Number(n).toLocaleString();
    }
  }
}
</script>

<style scoped>
.anomaly-card {
  background: var(--duallo-card-gradient);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  color: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-header {
  padding: 16px 18px 8px;
}

.card-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.card-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 18px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 18px;
}

.anomaly-hero {
  text-align: center;
  padding: 10px 0;
}

.anomaly-number {
  font-size: clamp(2.25rem, 5.5vw, 3.25rem);
  font-weight: 700;
  color: var(--duallo-accent-muted);
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.anomaly-sub-label {
  font-size: 0.85rem;
  color: #8aa0aa;
  margin-top: 6px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: 600;
}

.anomaly-breakdown {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  padding: 6px 10px;
}

.breakdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px;
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.breakdown-item:last-child {
  border-bottom: none;
}

.breakdown-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.dot-pending {
  background: #f59e0b;
  box-shadow: 0 0 6px rgba(245, 158, 11, 0.5);
}

.dot-accepted {
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.5);
}

.dot-rejected {
  background: #ef4444;
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);
}

.breakdown-label {
  flex: 1 1 auto;
  color: #cfd8dc;
  font-weight: 500;
}

.breakdown-value {
  color: #ffffff;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 600px) {
  .card-body {
    padding: 6px 14px 14px;
  }

  .breakdown-item {
    font-size: 0.9rem;
  }
}
</style>
